import { useEffect } from 'react';

export default function Up() {
  useEffect(() => {
    // Set content type and write response for client-side routing
    document.documentElement.setAttribute('data-status', 'OK');
  }, []);

  return null;
}
